import { render, staticRenderFns } from "./ClientCreatorWidget.vue?vue&type=template&id=c46e478c&scoped=true"
import script from "./ClientCreatorWidget.vue?vue&type=script&lang=js"
export * from "./ClientCreatorWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46e478c",
  null
  
)

export default component.exports